/**
 * AJAX-filtering en paginering voor overzichten uit includes/archive-filters.php.
 *
 * Per overzicht (wortel met [data-filter-key]):
 *   data-ajax-url           admin-ajax.php
 *   data-locked-filters     JSON-object met vaste filters die altijd meegaan
 *   data-empty-text         tekst als er niets gevonden is
 *   data-scroll-on-pagination   scrollt naar boven bij een andere pagina
 *   [data-filter-results]   wordt vervangen door de nieuwe kaarten
 *   [data-filter-pagination] wordt vervangen door de nieuwe paginering
 *   select.pk-select-input[name]  een filter; name = taxonomie, value = term-slug
 */
document.querySelectorAll("[data-filter-key]").forEach((root) => {
	const key = root.dataset.filterKey;
	const results = root.querySelector("[data-filter-results]");
	const paginationWrap = root.querySelector("[data-filter-pagination]");
	const selects = [...root.querySelectorAll("select.pk-select-input[name]")];
	const taxonomies = selects.map((select) => select.name);

	if (!key || !results || !root.dataset.ajaxUrl) return;

	let locked = {};
	try {
		locked = root.dataset.lockedFilters ? JSON.parse(root.dataset.lockedFilters) : {};
	} catch (error) {
		locked = {};
	}

	let active = {};
	let paged = 1;
	let requestId = 0;

	const readUrlState = () => {
		const params = new URLSearchParams(window.location.search);

		active = {};
		taxonomies.forEach((taxonomy) => {
			const values = params.getAll(taxonomy).flatMap((value) => value.split(",")).filter(Boolean);
			if (values.length) active[taxonomy] = values;
		});
		paged = Math.max(1, parseInt(params.get("filter_page"), 10) || 1);
	};

	const syncControls = () => {
		selects.forEach((select) => {
			select.value = (active[select.name] || [])[0] || "";
		});
	};

	const updateUrl = () => {
		const url = new URL(window.location.href);

		taxonomies.forEach((taxonomy) => {
			url.searchParams.delete(taxonomy);
			if ((active[taxonomy] || []).length) url.searchParams.set(taxonomy, active[taxonomy].join(","));
		});

		if (paged > 1) url.searchParams.set("filter_page", paged);
		else url.searchParams.delete("filter_page");

		window.history.pushState({ filterKey: key }, "", url);
	};

	const bindPagination = () => {
		if (!paginationWrap) return;

		paginationWrap.querySelectorAll("a[data-page]").forEach((link) => {
			link.addEventListener("click", (event) => {
				event.preventDefault();
				paged = parseInt(link.dataset.page, 10) || 1;

				if (root.hasAttribute("data-scroll-on-pagination")) {
					root.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "start" });
				}

				request();
			});
		});
	};

	const request = (updateBrowserUrl = true) => {
		const thisRequest = ++requestId;

		results.classList.add("is-loading");
		results.setAttribute("aria-busy", "true");

		const body = new URLSearchParams();
		body.set("action", "hollandia_archive_filter");
		body.set("filter_key", key);
		body.set("paged", paged);
		body.set("path", window.location.pathname);

		Object.entries(active).forEach(([taxonomy, slugs]) => slugs.forEach((slug) => body.append(`filters[${taxonomy}][]`, slug)));
		Object.entries(locked).forEach(([taxonomy, slugs]) => slugs.forEach((slug) => body.append(`locked[${taxonomy}][]`, slug)));

		fetch(root.dataset.ajaxUrl, { method: "POST", credentials: "same-origin", body })
			.then((response) => {
				if (!response.ok) throw new Error("request failed");
				return response.json();
			})
			.then((json) => {
				// Een oudere, tragere aanvraag mag een nieuwere niet overschrijven.
				if (thisRequest !== requestId) return;
				if (!json.success) throw new Error("request failed");

				if (json.data.html) {
					results.innerHTML = json.data.html;
				} else {
					const message = document.createElement("p");
					message.className = "vacancies-empty";
					message.textContent = root.dataset.emptyText || "";
					results.replaceChildren(message);
				}

				if (paginationWrap) paginationWrap.innerHTML = json.data.pagination;
				bindPagination();

				if (updateBrowserUrl) updateUrl();
				root.dispatchEvent(new CustomEvent("archive-filter:updated"));
			})
			.catch(() => {
				// Bij een fout blijven de huidige resultaten staan.
			})
			.finally(() => {
				if (thisRequest !== requestId) return;
				results.classList.remove("is-loading");
				results.setAttribute("aria-busy", "false");
			});
	};

	selects.forEach((select) => {
		select.addEventListener("change", () => {
			if (select.value) active[select.name] = [select.value];
			else delete active[select.name];

			paged = 1;
			request();
		});
	});

	readUrlState();
	syncControls();
	bindPagination();

	window.addEventListener("popstate", () => {
		readUrlState();
		syncControls();
		request(false);
	});

	// Terug uit de bfcache: de keuzelijsten opnieuw gelijkzetten met de URL.
	window.addEventListener("pageshow", (event) => {
		if (!event.persisted) return;
		readUrlState();
		syncControls();
	});
});
